import { Check } from 'lucide-react'
import { type AudioTrackBindingState } from '../../../api'
import { Modal } from '../../../components/ui'
import styles from './AudioAssignmentsModeSheet.module.css'

export type AudioAssignmentsModeOption = {
  count: number
  description: string
  label: string
  value: AudioTrackBindingState
}

type AudioAssignmentsModeSheetProps = {
  onClose: () => void
  onSelect: (state: AudioTrackBindingState) => void
  options: AudioAssignmentsModeOption[]
  value: AudioTrackBindingState
}

export const AudioAssignmentsModeSheet = ({
  onClose,
  onSelect,
  options,
  value
}: AudioAssignmentsModeSheetProps) => {
  const selectMode = (nextValue: AudioTrackBindingState): void => {
    onSelect(nextValue)
    onClose()
  }

  return (
    <Modal
      backdropClassName={styles.backdrop ?? ''}
      mobilePresentation="sheet"
      onClose={onClose}
      panelClassName={styles.panel ?? ''}
      title={<h2>Assignment mode</h2>}
    >
      <div className={styles.options} role="listbox" aria-label="Assignment mode">
        {options.map((option) => {
          const selected = value === option.value

          return (
            <button
              aria-selected={selected}
              className={selected ? styles.optionSelected : styles.option}
              key={option.value}
              onClick={() => selectMode(option.value)}
              role="option"
              type="button"
            >
              <span>
                <strong>{option.label}</strong>
                <small>{option.description}</small>
              </span>
              <em>{option.count}</em>
              {selected && <Check size={17} />}
            </button>
          )
        })}
      </div>
    </Modal>
  )
}
